// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
import observeAndExecute from './utils/observe-and-execute';
const fCarousels = require('./components/carousels');
const fAccordion = require('./components/accordion');
const fTabContent = require('./components/tab-content');
const fHeader = require('./components/header');
const fLazyLottiePlayer = require('./components/lazy-lottie-player');
const fPopupVideo = require('./components/popup-video');
const fFlexibleContent = require('./components/flexible-content');
const fTableOfContents = require('./components/table-of-contents');
const fFlowContent = require('./components/flow-content');
import VueComponents from "./components/vue-components";
// const fSelect = require('./components/select');
const fGsapController = require('./components/gsap-controller')

document.addEventListener("DOMContentLoaded", () => {
    fSmoothScroll()
    // fVueComponents.init()
    // fSelect.init()
    fGsapController.init()
    fAccordion();
    fHeader();
    fTabContent();
    fLazyLottiePlayer();
    fFlexibleContent();
    fTableOfContents();
    fFlowContent();
    fPopupVideo();

    new VueComponents({
        components: [
            {name: 'members', file: () => import('./vue/features/members/members.vue')},
            {name: 'documents', file: () => import('./vue/features/documents/documents.vue')},
        ],
    });

    observeAndExecute(".swiper", {
        callback: () => fCarousels.init(),
        disconnect: true,
    })
    observeAndExecute(".animated-heading", {
        callback: () => fCarousels.init(),
        disconnect: true,
    })

    observeAndExecute("[data-lazy-video]", {
        callback: (e) => {
            e.setAttribute("src", e.dataset.lazyVideo);
        } 
    })
})